import { TetherDialog } from './../../../common-module/modules/tether-dialog/tether-dialog';
import { IconGridComponent } from './../../../common-module/components/icon-grid/icon-grid.component';
import { TypeaheadComponent } from './../../../common-module/components/typeahead/typeahead.component';
import { WizardHeaderComponent } from './../../../common-module/components/wizard-header/wizard-header.component';
import { DialogBoxComponent } from './../../../base-module/components/dialog-box/dialog-box.component';
import {
  Component,
  OnInit,
  ViewChild,
  Input,
  ChangeDetectorRef,
  ElementRef
} from '@angular/core';
import { ShoppingCartService } from '../../../../services/shopping-cart.service';
import { AllocationType } from '../../../../models/allocation-type.enum';
import { LoyaltyCardService } from '../../../../services/loyalty-card.service';
import { ReservationCreate } from '../../../reservation-module/modules/reservation-create-module/models/reservation-create';
import { CrmAnonymousUser } from '../../../../models/crm-anonymous-user';
import { ReservationService } from '../../../reservation-module/services/reservation.service';
import { NotificationService } from '../../../../services/notification.service';
import { CrmMemberService } from '../../../../services/crm-member.service';

@Component({
  selector: 'app-loyalty-card-check-reservation-modal',
  templateUrl: './loyalty-card-check-reservation-modal.component.html',
  styleUrls: ['./loyalty-card-check-reservation-modal.component.scss'],
  providers: [LoyaltyCardService, ReservationService, CrmMemberService]
})
export class LoyaltyCardCheckReservationModalComponent implements OnInit {
  @ViewChild(DialogBoxComponent) dialogBox: DialogBoxComponent;
  @ViewChild(WizardHeaderComponent) wizardHeader: WizardHeaderComponent;
  @ViewChild(TypeaheadComponent) typeahead: TypeaheadComponent;
  @ViewChild(IconGridComponent) iconGrid: IconGridComponent;


  @Input() title: string;
  @Input() eventId: number;

  @Input()
  settings: {
    levels: { key: string; title: string; params?: any }[];
  };

  get levels() {
    return this.settings.levels;
  }
  public currentLevel: { key: string; title: string; params?: any };
  public currentLevelIndex = -1;

  allocationType = AllocationType;
  public isPromising = false;
  filteredPerformances: any;
  isLoading = false;
  event: Object[];
  countOfSelected = [];
  isToggleOpen = [];
  allocationTypeColor = ['#cc3dfc', '#FBCA64', '#9EFD44'];
  selectedVariants: Object = {};
  currentValue = [];
  loyaltyCardIsValid = false;
  phoneNumberIsValid = true;
  loyaltyCardNumber: string;
  public selectedProduct = '';
  selectedPerformance = '';
  customer: Object[];

  constructor(
    private shoppingCartService: ShoppingCartService,
    public tether: TetherDialog,
    public changeDetector: ChangeDetectorRef,
    private reservationService: ReservationService,
    private notificationService: NotificationService,
    private crmMemberUserService: CrmMemberService,
    private loyaltyCardService: LoyaltyCardService,
    private elementRef: ElementRef
  ) {
    this.shoppingCartService.setCustomEndpoint(
      'SelectEvent?includeStateModel=true',
      true
    );
    this.crmMemberUserService.setCustomEndpoint('SearchCustomers', true);
  }

  ngOnInit() {
    let save = this.shoppingCartService.create({ EventId: this.eventId });
    save.subscribe(
      result => {
        this.isLoading = false;
        this.shoppingCartService.setCurrentState(result);
        if (result && result.CurrentState) {
          this.shoppingCartService.setCurrentState(result);
          if (result['CurrentState'] === 1) {
            this.shoppingCartService.getCartSummary();
            this.eventState = result['State']['Event'];
            this.filteredPerformances = this.stateData['Performances'].map(p =>
              Object.assign({}, p)
            );
            for (
              let i = 0;
              i < Object.keys(this.stateData['Performances']).length;
              i++
            ) {
              console.warn(1);
              for (
                let a = 0;
                a < this.stateData['Performances'][i]['Products'].length;
                a++
              ) {
                console.warn(2);
                for (
                  let c = 0;
                  c <
                  this.stateData['Performances'][i]['Products'][a]['Variants']
                    .length;
                  c++
                ) {
                  console.warn(3);
                  this.countOfSelected[
                    this.stateData['Performances'][i]['Products'][a][
                      'Variants'
                    ][c]['Id']
                  ] = this.stateData['Performances'][i]['Products'][a][
                    'Variants'
                  ][c]['CountOfProductsSelected'];
                }
              }
            }
          }
        }
      },
      error => {
        this.isLoading = false;
      }
    );

    // Servis dışardan çağrılırsa bu blok iptal edilecek
    this.title = 'Loyalty Card';
    this.settings = {
      levels: [
        { key: 'loyaltyCard', title: 'Loyalty Card Kontrolü' },
        { key: 'reservation', title: 'Rezervasyon Oluşturma' }
      ]
    };
  }

  ngAfterViewInit() {
    this.gotoLevel(0);
  }

  set eventState(state) {
    this.event = state;
  }

  get stateData() {
    return this.event;
  }

  wizardActionHandler(event: { action: string; params?: any }) {
    switch (event.action) {
      case 'goBack':
        this.previousLevel();
        break;
    }
  }

  typeLoyaltyCardEventHandler(event) {
    if (typeof event !== 'undefined' && event !== '') {
      this.loyaltyCardIsValid = true;
      this.loyaltyCardNumber = event;
    } else {
      this.loyaltyCardIsValid = false;
    }
  }

  changeLoyaltyCardEventHandler(event) {
    if (typeof event !== 'undefined' && event !== '') {
      this.loyaltyCardIsValid = true;
      this.loyaltyCardNumber = event;
    } else {
      this.loyaltyCardIsValid = false;
    }
  }

  typeCustomerEventHandler(event) {
    this.customer = event;
    console.log(event);
    if (event.action === 'remove') {
      this.customer = null
    }
  }

  changeCustomerEventHandler(event) {
    console.log(event);
    this.customer = event;
    if (event.action === 'remove') {
      this.customer = null
    }
  }

  isValidControl() {
    return this.loyaltyCardIsValid && this.phoneNumberIsValid ? true : false;
  }

  nextLevel() {
    this.gotoLevel(
      Math.min(this.currentLevelIndex + 1, this.levels.length - 1)
    );
  }

  previousLevel() {
    this.gotoLevel(Math.max(this.currentLevelIndex - 1, 0));
  }

  gotoLevel(key: any) {
    this.isPromising = false;
    if (Number.isInteger(key)) {
      this.currentLevelIndex = key;
    } else {
      let self = this;
      this.levels.forEach(function(item, index) {
        if (item.key === key) {
          self.currentLevelIndex = index;
          return;
        }
      });
    }
    let targetLevel = this.levels[this.currentLevelIndex];
    if (targetLevel !== this.currentLevel) {
      this.currentLevel = targetLevel;
    }

    if (this.currentLevel && this.currentLevel.key === 'template') {
    }
    this.changeDetector.detectChanges();
    this.tether.position();
  }

  productButtonEnabledCheck(productId) {
    if (this.selectedProduct === '') {
      return 'primary';
    } else if (this.selectedProduct === productId) {
      return 'danger';
    } else {
      return 'primary';
    }
  }

  getProductButtonLabel(productId) {
    if (this.selectedProduct === '') {
      return 'SEÇİM';
    } else if (this.selectedProduct === productId) {
      return 'İPTAL ET';
    } else {
      return 'SEÇİM';
    }
  }

  purchaseButtonEnabledCheck() {
    return this.selectedProduct === '' ? false : true;
  }

  dismissHandler(event) {
    this.tether.dismiss(event);
  }

  public loyaltyCardControl() {
    if (this.isValidControl()) {
      this.isLoading = true;
      this.loyaltyCardService
        .CheckLoyaltyCardLimit(this.loyaltyCardNumber, this.eventId)
        .subscribe(
          result => {
            console.log(result._body);
            if (result._body > 0) {
              this.loyaltyCardIsValid = false;
              // this.phoneNumberIsValid = false;
              this.isLoading = false;
              this.nextLevel();
            } else {
              this.isLoading = false;
              this.notificationService.add({
                text: 'Yetersiz Loyaly Card Limiti',
                type: 'warning'
              });
            }
          },
          err => {
            this.isLoading = false;
            this.notificationService.add({
              text: err.Message,
              type: 'warning'
            });
            throw err;
          }
        );
    }
  }

  toggle($event, index) {
    this.isToggleOpen[index] = $event;
  }

  getColor(type: any) {
    return this.allocationTypeColor[this.allocationType[type]];
  }

  maxProductCount(product) {
    return product &&
      product['MaxAllowedCountOfProducts'] &&
      product['MaxAllowedCountOfProducts'] > 0
      ? product['MaxAllowedCountOfProducts']
      : 0;
  }

  selectProduct(productId, performanceId) {
    if (this.selectedProduct === '') {
      this.selectedProduct = productId;
      this.selectedPerformance = performanceId;
    } else if (this.selectedProduct === productId) {
      this.selectedProduct = '';
    } else {
      this.selectedProduct = productId;
      this.selectedPerformance = performanceId;
    }
  }

  createLoyaltyCardInvitation() {
    if (this.purchaseButtonEnabledCheck()) {
      this.isLoading = true;
      let performanceId = parseInt(this.selectedPerformance, 10);
      let productId = parseInt(this.selectedProduct, 10);

      let crmUser = new CrmAnonymousUser();
      console.log(this.customer);
      if (this.customer !== undefined && this.customer !== null) {
        crmUser.LastName = this.customer['Surname'];
        crmUser.Email = this.customer['Email'];
        crmUser.PhoneNumber = this.customer['PhoneNumber'];
        crmUser.FirstName = this.customer['Name'];
        crmUser.CrmMemberId = this.customer['MemberId'];
      } else {
        crmUser.LastName = 'mobilet';
        crmUser.Email = 'biletlericinmobilet@gmail.com';
        crmUser.PhoneNumber = '905380965157';
        crmUser.FirstName = 'mobilet';
        crmUser.CrmMemberId = 3248;
      }
      console.log(crmUser);
      let newReservation: ReservationCreate = {
        Name: 'Loyalty Card',
        Description: 'Loyalty Card',
        InvitationType: 2,
        EventId: this.eventId,
        LoyaltyCardNumber: this.loyaltyCardNumber,
        CustomerSeats: [
          {
            Customer: crmUser,
            Seats: [
              {
                PerformanceId: performanceId,
                ProductId: productId
              }
            ]
          }
        ]
      };

      this.reservationService.createInvitation(newReservation).subscribe(
        response => {
          this.isLoading = false;
          this.notificationService.add({
            text: 'Loyalty Card Daveti Başarıyla Oluşturuldu.',
            type: 'success'
          });
          this.dismissHandler(this.event);
        },
        error => {
          this.isLoading = false;
          this.notificationService.add({
            text: 'Loyalty Card Daveti oluşturulurken bir problem oluştu.',
            type: 'danger'
          });
        }
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/boxoffice-module/common/loyalty-card-check-reservation-modal/loyalty-card-check-reservation-modal.component.ts